import { useEffect, useRef, useState } from "react";
import RolesTable from "./RolesTable";
import CreateRoleDialog from "./create/CreateRoleDialog";
import useAxios from "../../../../../../hooks/useAxios";
import useLoading from "../../../../../../shared/components/loading/useLoading";
import useToastWrapper from "../../../../../../hooks/useToastWrapper";
import { catchFunction } from "../../../../../../shared/lib/utils";
import { API_SECURITY_CENTRE_ROLES } from "../../../../../../shared/lib/apiEndpointsResolver";
import SearchInput from "../../../../../../shared/components/input/SearchInput";
import OverviewTabContent from "../../../../../../shared/components/overview-panel/OverviewTabContent";
import OverviewComponent from "../../../../../../shared/components/overview-panel/OverviewComponent";

const RolesOverview = () => {
  const axios = useAxios();
  const { setLoading } = useLoading();
  const [roles, setRoles] = useState([]);
  const rolesRef = useRef([]);
  const toast = useToastWrapper();
  const breadcrumbItems = [{ title: "Roles" }];

  const findRoles = () => {
    setLoading(true);
    axios
      .get(API_SECURITY_CENTRE_ROLES)
      .then((response) => {
        setRoles(response.data);
        rolesRef.current = response.data;
      })
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const filterRoles = (searchEvent) => {
    const term = searchEvent.target.value.toLowerCase();
    setRoles(
      rolesRef.current.filter(
        (x) =>
          x.code.toLowerCase().includes(term) ||
          x.name.toLowerCase().includes(term),
      ),
    );
  };

  const onRoleCreation = (formValues) => {
    setLoading(true);
    axios
      .post(API_SECURITY_CENTRE_ROLES, formValues)
      .then((response) => {
        toast.success(`Rol ${response.data.name} creado correctamente`);
        findRoles();
      })
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const OverviewOptions = (
    <>
      <SearchInput
        onChangeHandler={filterRoles}
        placeholder="Buscar por código o nombre"
      />
      <CreateRoleDialog onSubmitHandler={onRoleCreation} />
    </>
  );

  const rolesTabs = [
    {
      trigger: { value: "all", label: "Todos" },
      content: (
        <OverviewTabContent
          value="all"
          title="Roles disponibles"
          description="Listado de roles de todas las apps de AdQuiver"
        >
          <RolesTable data={roles} />
        </OverviewTabContent>
      ),
    },
  ];

  useEffect(() => {
    findRoles();
  }, []);

  return (
    <OverviewComponent
      breadcrumbItems={breadcrumbItems}
      options={OverviewOptions}
      tabs={rolesTabs}
    />
  );
};

export default RolesOverview;
